import { type JudicialPreanalysisStatus } from '@onr/schema'

import { type OnrApiMutationOptions, useOnrApi } from './mutation/useOnrApi.ts'

interface JudicialPreanalysisAction {
  personCode: string
  expectedStatus: JudicialPreanalysisStatus
}

export type UpdateJudicialPreanalysisVariables =
  | (JudicialPreanalysisAction & { action: 'start' | 'authorize' | 'complete' })
  | (JudicialPreanalysisAction & { action: 'refuse' | 'note'; note: string })

export const PREANALYSIS_STATUS_CHANGED_CODE = 'functions/aborted'
export const PREANALYSIS_CONTRARY_DECISION_TODAY_CODE = 'functions/already-exists'

export const useUpdateJudicialPreanalysis = (
  options?: OnrApiMutationOptions<void, UpdateJudicialPreanalysisVariables>
) =>
  useOnrApi<void, UpdateJudicialPreanalysisVariables>({
    type: 'updateJudicialPreanalysis',
    ...options,
  })
